import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import FullWidthContainer from '@starbucks-web/pattern-library/lib/components/full-width-container';

import ColumnsTemplate from '../columns-template';
import Description from './description';
import FullNutritionLink from './full-nutrition-link';
import NutritionSummary from './nutrition-summary';
import StarCost from 'ordering/app/components/shared/star-cost';
import { usePdpContext } from '../pdp-provider';

import styles from './styles.cssm';
import messages from './messages';

const SummaryAside = () => {
  const { formatMessage } = useIntl();
  const starCost = usePdpContext().product?.starCost;

  const leftColumn = (
    <React.Fragment>
      {Boolean(starCost) && (
        <StarCost
          className={classNames(
            styles.starCost,
            'inline-block px2 mb3 color-gold text-xxs'
          )}
          starCost={starCost}
        />
      )}
      <Description />
      <NutritionSummary />
      <FullNutritionLink />
    </React.Fragment>
  );

  return (
    <FullWidthContainer className="bg-houseGreen py5 mt9">
      <aside aria-label={formatMessage(messages.summaryLabel)}>
        <ColumnsTemplate leftColumn={leftColumn} />
      </aside>
    </FullWidthContainer>
  );
};

export default SummaryAside;
